var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","justify-center":"","py-4":""}},[_c('h4',{staticClass:"defaultColor--text font-weight-regular"},[_vm._v(_vm._s(_vm.defaultText))])])}
var staticRenderFns = []

export { render, staticRenderFns }